<template>
    <div
        id="be-privacy-conditions"
        class="bg-light"
    >
        <div class="body-wrapper">
            <backend-header />
            <main>
                <div class="barra-titolo-azioni bg-white border-bottom py-2">
                    <div class="container-fluid">
                        <div class="row d-flex justify-content-between flex-wrap align-items-center">
                            <div class="col-sm-5">
                                <h1 class="mb-0">{{ $t("Privacy e Condizioni") }}</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid mt-3">
                    <div class="form-container row">
                        <div
                            id="step-2"
                            class="step col-lg-8 offset-lg-2 col-md-10 offset-md-1"
                            v-if="!loading"
                        >
                            <div class="mt-3">
                                <h4>{{$t('DPA Fotonegozio')}}</h4>
                                <div class="mt-3 mb-3">
                                    <div
                                        class="textarea"
                                        v-html="getFilledDocument('DPA')"
                                    ></div>
                                    <div class="d-flex justify-content-end ">
                                        <a
                                            href="#"
                                            @click.prevent="onReadFullPage('DPA')"
                                        >
                                            {{$t('Leggi a piena pagina')}}
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="!hasCustomGdpr"
                                class="mt-3"
                            >
                                <h4>{{$t('Informativa')}}</h4>
                                <div class="mt-3 mb-3">
                                    <div
                                        class="textarea"
                                        v-html="getFilledDocument('INFORMATIVA')"
                                    ></div>
                                    <div class="d-flex justify-content-end ">
                                        <a
                                            href="#"
                                            @click.prevent="onReadFullPage('INFORMATIVA')"
                                        >
                                            {{$t('Leggi a piena pagina')}}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <!--h6>{{$t('Carica informativa personalizzata (file PDF)')}}</h6>
                            <div class="mt-3 mb-3">
                                <input
                                    type="file"
                                    accept="application/pdf"
                                    name="custom-gdpr"
                                    ref="customGdpr"
                                    id="custom-gdpr"
                                    class="col order-3 order-md-2 mt-2 mt-md-0"
                                    @change.prevent="uploadCustomGdpr()"
                                />
                            </div-->

                            <div
                                v-if="!hasCustomGdpr"
                                class="mt-3"
                            >
                                <h4>{{$t('Oppure, carica la tua informativa personalizzata (in formato PDF)')}}</h4>
                                <p class="font-weight-bold">Attenzione: il file è soggetto ad approvazione. Potrebbero essere necessari 15 giorni di tempo.</p>
                                <div class="mt-3 mb-3">
                                    {{$t('Voglio essere messo in contatto con il vostro ufficio legale')}}
                                    <b-card>
                                        <validation-observer
                                            v-slot="{ handleSubmit }"
                                            tag="form"
                                            ref="custom-gdpr-form-1"
                                            id="customGdprFormStep1"
                                        >
                                            <fieldset>
                                                <div class="form-row">
                                                    <h6>{{$t('Mittente')}}</h6>
                                                    <div class="mb-3 col-sm-12">
                                                        {{ shop.ragioneSociale }}<br />
                                                        {{ shop.indirizzo }} {{ shop.cap }} - {{ shop.citta }} ({{ shop.provincia }})<br />
                                                        Informazioni di contatto:<br />
                                                        <font-awesome-icon
                                                            class="ml-1 mr-1"
                                                            :icon="['fas', 'phone']"
                                                        /> {{ shop.telefono }}<br />
                                                        <font-awesome-icon
                                                            class="ml-1 mr-1"
                                                            :icon="['fas', 'envelope']"
                                                        /> {{ shop.email }}
                                                    </div>
                                                </div>
                                                <div class="form-row">
                                                    <validation-provider
                                                        rules="required"
                                                        v-slot="{errors}"
                                                        class="mb-3 w-100"
                                                    >
                                                        <h6>{{$t('Messaggio')}}</h6>
                                                        <textarea
                                                            class="w-100"
                                                            rows=4
                                                            placeholder="Inserisci il tuo messaggio"
                                                            v-model="message"
                                                        ></textarea>
                                                        <span class="text-danger">{{errors[0]}}</span>
                                                    </validation-provider>
                                                </div>
                                                <div class="form-row">
                                                    <validation-provider
                                                        rules="required|ext:pdf"
                                                        ref="provider"
                                                        class="w-100"
                                                        v-slot="{ validate, errors }"
                                                    >
                                                        <h6>{{$t('Informativa personalizzzata')}}</h6>
                                                        <div class="mt-3">
                                                            <input
                                                                type="file"
                                                                accept="application/pdf"
                                                                name="custom-gdpr"
                                                                ref="customGdpr"
                                                                id="custom-gdpr"
                                                                class="col order-3 order-md-2 mt-2 mt-md-0"
                                                                @change="handleFileChange"
                                                            />
                                                            <span class="text-danger">{{errors[0]}}</span>
                                                        </div>
                                                    </validation-provider>
                                                </div>
                                                <div class="text-md-right">
                                                    <a
                                                        role="button"
                                                        class="pulsante-step-next btn btn-primary btn-rikorda1 mt-3 mb-0 d-block d-md-inline-block mx-auto mx-md-0"
                                                        @click.prevent="handleSubmit(goToStepCustom)"
                                                    >{{ $t('Invia') }}</a>
                                                </div>
                                            </fieldset>
                                        </validation-observer>
                                    </b-card>

                                </div>
                            </div>
                            <div v-else>
                                <h4>{{$t('Informativa personalizzata caricata')}}</h4>
                                <div
                                    id="iframe-wrapper"
                                    style="width:100%;height:78vh;overflow:auto;-webkit-overflow-scrolling: touch;"
                                >
                                    <embed
                                        :src="getDocumentUrlEndpoint()"
                                        type="application/pdf"
                                        width="100%"
                                        height="100%"
                                    >
                                </div>
                                <div class="text-center">
                                    <b-button
                                        v-b-modal.remove-custom-gdpr
                                        class="mt-2"
                                    >
                                        {{$t('RIMUOVI (ed usa l\'informativa predefinita)')}}
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <GDPRViewer
                ref="gdprViewer"
                :gdpr="gdprToView"
                :hasCustomGdpr="hasCustomGdpr"
                :shop="shop"
                :hasTempGdpr="hasTempGdpr"
                @clearTemp="clearTemp"
            >
                <slot></slot>
            </GDPRViewer>

            <b-modal
                id="customgdpr-modal"
                title="Invio informativa personalizzata effettuato"
                ok-title="Chiudi"
                ok-only
                @ok="onCustomGdprModalOk"
                @close="onCustomGdprModalOk"
            >
                <p
                    class="my-4 text-justify"
                    :class="{'text-danger': !customGdprResult}"
                >
                    {{ customGdprMessage }}
                </p>
            </b-modal>

            <!-- modale rimozione gdpr custom -->
            <b-modal
                id="remove-custom-gdpr"
                title="Rimuovi GDPR personalizzato"
                ref="removeGdprModal"
                :cancel-title="$t('Annulla')"
                :ok-title="$t('Rimuovi')"
                :ok-variant="'danger'"
                @ok.prevent="deleteCustomGdpr"
            >
                <p>
                    {{$t('Sei sicuro di voler rimuovere la tua informativa personalizzata e tornare all\'informativa predefinita fornita da Rikorda Eventi?')}}
                </p>
            </b-modal>

            <backend-footer />
        </div>
    </div>
</template>

<script>
import BackendHeader from "../../components/backend/Header";
import BackendFooter from "../../components/backend/Footer";
import GDPRViewer from "../../components/GDPRViewer";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, ext } from "vee-validate/dist/rules";

extend("required", {
    ...required,
    message: "Questo campo è obbligatorio"
});
extend("ext", {
    ...ext,
    message: "Formato non valido. Selezionare un file in formato PDF."
});

export default {
    name: "BackendPrivacyConditions",
    components: {
        GDPRViewer,
        BackendFooter,
        BackendHeader,
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            gdpr: {
                default: null,
                custom: null
            },
            gdprToView: null,
            shop: {},
            loading: true,
            forceModal: false,
            hasTempGdpr: false,
            message: "",
            customGdprResult: false,
            customGdprMessage: ""
        };
    },
    mounted() {
        this.$api
            .backendGetShopGdpr()
            .then((response) => {
                console.debug("BACKEND_GET_SHOP_GDPR", response);
                this.gdpr.default = {
                    dpa: response.docs.default.DPA,
                    informativa: response.docs.default.Informativa
                };
                this.gdpr.custom = response.docs.custom;
                this.shop = response.shop;
                this.loading = false;
            })
            .catch((error) => {
                console.error("BACKEND_GET_SHOP_GDPR", error);
            });
    },
    methods: {
        goToStepCustom() {
            this.$api
                .backendCustomGdprRequest(this.message)
                .then((response) => {
                    console.debug("BACKEND_CUSTOM_GDPR_REQUEST", response);
                    this.customGdprResult = true;
                    this.customGdprMessage = this.$t(
                        "L'informativa è stata inviata e sarà sottoposta ad approvazione da parte dell'ufficio legale."
                    );
                })
                .catch((error) => {
                    console.error("BACKEND_CUSTOM_GDPR_REQUEST", error);
                    this.customGdprResult = false;
                    this.customGdprMessage = this.$t(
                        "C'è stato un errore nell'invio dell'informativa."
                    );
                })
                .finally(() => {
                    this.$bvModal.show("customgdpr-modal");
                });
        },

        async handleFileChange(e) {
            const { valid } = await this.$refs.provider.validate(e);
            const file = this.$refs.customGdpr.files[0]; // <input type='file' />

            if (valid && file) {
                const uri =
                    process.env.VUE_APP_API_BASE_URL +
                    process.env.VUE_APP_API_UPLOAD_GDPR_ENDPOINT;
                const xhr = new XMLHttpRequest();
                const fd = new FormData();
                //let that = this; // Vue
                xhr.open("POST", uri, true);
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) {
                        switch (xhr.status) {
                            case 200:
                                console.debug("UPLOAD_CUSTOM_GDPR_OK");
                                break;
                            default:
                                console.debug("UPLOAD_CUSTOM_GDPR_ERROR");
                                break;
                        }
                    }
                };
                fd.append("file", file);
                fd.append("fkUtenteFotografo", this.shop.fkUtente);
                fd.append("uploadType", "upload_tmp");
                xhr.send(fd);
            }
        },

        onCustomGdprModalOk() {
            this.$bvModal.hide("customgdpr-modal");
        },

        onReadFullPage(docType) {
            this.hasTempGdpr = false;
            switch (docType) {
                case "DPA":
                    this.gdprTitleToView = "DPA Fotonegozio";
                    this.gdprToView = this.getFilledDocument("DPA");
                    break;
                case "INFORMATIVA":
                    this.gdprTitleToView =
                        "Allegato A: Informativa Rikorda Eventi";
                    this.gdprToView = this.getFilledDocument("INFORMATIVA");
                    break;
                case "TERMINICONDIZIONI":
                    this.gdprTitleToView = "Termini e Condizioni del servizio";
                    this.gdprToView = this.getFilledDocument(
                        "TERMINICONDIZIONI"
                    );
                    break;
            }
            this.$bvModal.show(this.$refs.gdprViewer.id);
        },
        getFilledDocument(docType) {
            var doc;
            switch (docType) {
                case "DPA":
                    doc = this.gdpr.default.dpa;
                    break;
                case "INFORMATIVA":
                    doc = this.gdpr.default.informativa;
                    break;
                default:
                    doc = "";
            }

            Array.from(Object.keys(this.shop)).forEach((el) => {
                if (el === "dpo") {
                    doc = doc.replaceAll(
                        "[[__DPO__]]",
                        this.shop[el]
                            ? this.shop[el]
                            : "non è stato individuato"
                    );
                }
                doc = doc.replaceAll(
                    "[[__" + el.toUpperCase() + "__]]",
                    this.shop[el]
                );
            });

            doc = doc.replaceAll(
                "[[__DATAACCETTAZIONE__]]",
                new Date().toLocaleDateString("it-IT", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric"
                })
            );

            return doc;
        },
        uploadCustomGdpr() {
            const file = this.$refs.customGdpr.files[0]; // <input type='file' />
            if (file) {
                const uri =
                    process.env.VUE_APP_API_BASE_URL +
                    process.env.VUE_APP_API_UPLOAD_GDPR_ENDPOINT;
                const xhr = new XMLHttpRequest();
                const fd = new FormData();
                let that = this; // Vue
                xhr.open("POST", uri, true);
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        console.debug("UPLOAD_CUSTOM_GDPR_OK");
                        that.$refs.customGdpr.value = "";
                        that.hasTempGdpr = true;
                        that.gdprToView = "";
                        that.$bvModal.show(that.$refs.gdprViewer.id);
                    }
                };
                fd.append("file", file);
                fd.append("fkUtenteFotografo", this.shop.fkUtente);
                fd.append("uploadType", "upload_tmp");
                xhr.send(fd);
            }
        },
        getDocumentUrlEndpoint() {
            return (
                process.env.VUE_APP_API_BASE_URL +
                process.env.VUE_APP_API_UPLOAD_GDPR_ENDPOINT +
                "?fkUtenteFotografo=" +
                this.shop.fkUtente +
                "&stato=CONFERMATO&uploadType=view"
            );
        },
        clearTemp() {
            this.hasTempGdpr = false;
            this.$api
                .backendGetShopGdpr()
                .then((response) => {
                    console.debug("BACKEND_GET_SHOP_GDPR", response);
                    this.gdpr.custom = response.docs.custom;
                })
                .catch((error) => {
                    console.error("BACKEND_GET_SHOP_GDPR", error);
                });
        },
        deleteCustomGdpr() {
            this.$api
                .backendRemoveGdpr()
                .then((response) => {
                    console.debug("BACKEND_REMOVE_GDPR", response);
                    this.$refs.removeGdprModal.hide();
                    this.$api
                        .backendGetShopGdpr()
                        .then((response) => {
                            console.debug("BACKEND_GET_SHOP_GDPR", response);
                            this.gdpr.custom = response.docs.custom;
                        })
                        .catch((error) => {
                            console.error("BACKEND_GET_SHOP_GDPR", error);
                        });
                })
                .catch((error) => {
                    console.error("BACKEND_GET_SHOP_GDPR", error);
                });
        }
    },
    computed: {
        hasCustomGdpr() {
            return (
                this.gdpr.custom &&
                Object.prototype.hasOwnProperty.call(
                    this.gdpr.custom,
                    "fkUtente"
                )
            );
        }
    }
};
</script>

<style scoped>
div.textarea {
    border: 1px inset #ccc;
    width: 100%;
    height: 300px;
    overflow: auto;
}
</style>
